@if (feedback) {
  <div [ngClass]="feedback.type === error ? 'alert alert-danger' : 'alert alert-success'" role="alert">
    {{feedback.message}}
  </div>
}
